import { format } from "date-fns";
import {
  getWeekDay,
  removeTimezoneFromDateString,
} from "../../../../utils/dateUtils";
import { capitalizeFirstLetter } from "../../../../utils/misc";
import { formatInTimeZone } from "date-fns-tz";
import { CalendarItemConfirmationScope } from ".";

const weekMap = {
  su: "Sun",
  mo: "Mon",
  tu: "Tue",
  we: "Wed",
  th: "Thu",
  fr: "Fri",
  sa: "Sat",
};

export function getClassItemInfo(
  scope: CalendarItemConfirmationScope,
  classItem: {
    startDatetime: string;
    calendarItemType: {
      name: string;
    };
    templates?: { days: string[]; startDate: string; startTime: string }[];
  },
) {
  if (!classItem) {
    return null;
  }

  const weekDay = getWeekDayName(classItem?.startDatetime);
  const time = getTimeFormatted(classItem.startDatetime);
  const name = classItem.calendarItemType?.name;
  const date = formatInTimeZone(
    classItem.startDatetime,
    "UTC",
    "eee, MMM d, yyyy",
  );

  const series = classItem.templates
    ?.map((item) => {
      const time = getTimeFormatted(
        `${item.startDate}T${item.startTime}:00.000Z`,
      );
      const days = item.days.map((item) => weekMap[item]).join(", ");
      return `${time} ${name} on ${days}`;
    })
    .join(" and ");

  switch (scope) {
    case "this": {
      return `Edit only this class (${time} ${name} on ${date}).`;
    }
    case "all of weekday": {
      return `Edit this class, and all future ${weekDay} classes in this series (${time} ${name}).`;
    }
    case "all": {
      return `Edit this class, and all future classes in this series (${series}).`;
    }
    default: {
      return null;
    }
  }
}

function getWeekDayName(date: string) {
  const startDate = format(removeTimezoneFromDateString(date), "yyyy-MM-dd");
  return capitalizeFirstLetter(getWeekDay(startDate).toLowerCase());
}

function getTimeFormatted(date: string) {
  return formatInTimeZone(date, "UTC", "h:mma")
    .replace(":00", "")
    .toLocaleLowerCase();
}
